import { render, staticRenderFns, recyclableRender, components } from "./notify.vue?vue&type=template&id=8c6df08c&scoped=true&"
var renderjs
import script from "./notify.vue?vue&type=script&lang=js&"
export * from "./notify.vue?vue&type=script&lang=js&"
import style0 from "./notify.vue?vue&type=style&index=0&id=8c6df08c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_@dcloudio_vue-cli-plugin-uni@2.0.0-28320200727001@@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6df08c",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/personalCenter/notify.vue"
export default component.exports